import { useQuestionizerStore } from "../types/state";
import { SkipLink } from "./skip-link.tsx";

export default function StepNavigation (){
  const stepsCount = useQuestionizerStore((state) => state.stepsCount());
  const step = useQuestionizerStore((state) => state.step);
  const active_group = useQuestionizerStore((state) => state.active_group);

  let steps = [];
  let index_label = 0;
	
  for (let i = 0; i < stepsCount; i++){
	  
	index_label++;
	steps.push(
      <Step 
        key={i} 
        index={i} 
        label={index_label} 
        totalSteps={stepsCount}
        active={i === step}
      />
    );
	
  }
  return <div role="menubar" inert={active_group ? true : false} className='step_navigation'>
  {!active_group && <SkipLink label="Menü überspringen" query='#form button, #form div[role="checkbox"], #form div[role="radio"]' />}
	<StepReset/>
    {steps}
  <ContrastMode/>
  </div>
}

function StepReset(){
  const resetState = useQuestionizerStore((state) => state.resetState);
  const line_active_style = " step_navigation__line step_navigation__line--active ";
  const point_reset_style = " step__point step_navigation__step_reset ";

  return <button type="button" aria-label="Neu Abfrage starten" role="menuitem" tabIndex={0} className={'step_navigation__step'} 
      onClick={()=>{
			  resetState();
			}} 
      onKeyUp={()=>{
        if ((event.code != " ")  && (event.code != "Enter")) { return } 
        resetState();
      }}
		>
      <div role="presentation" className={line_active_style}></div>
      <div role="presentation" className={point_reset_style}>
		    <abbr role="presentation" title="Neu Abfrage starten"><div className={'icon-inline--right icon-reset--white'}></div></abbr>
	    </div>
    </button>
}

function ContrastMode(){
  const toggle_contrast_mode = useQuestionizerStore((state) => state.toggle_contrast_mode);
  const config = useQuestionizerStore((state) => state.config);


  return <button type="button" aria-label="Kontrastmodus umschalten" role="menuitem" 
      style={{ display: config?.show_btn_contrast_mode === true ? 'block' : 'none' }}
	  tabIndex={0} 
	  className={'step_navigation__step'} 
      onClick={(event)=>{
        event.preventDefault();
        toggle_contrast_mode();
			}}
      onKeyUp={()=>{
        if ((event.code != " ")  && (event.code != "Enter")) { return } 
        toggle_contrast_mode();
      }}>
      <abbr role="presentation" className="step__point" title="Kontrastmodus umschalten"><div className={'icon icon-access'}></div></abbr>
		</button>
}


function Step(props: {index: number, label: number, totalSteps: number, active: boolean}) {
  const setStep = useQuestionizerStore((state) => state.setStep);
  const step = useQuestionizerStore((state) => state.step);
  const step_progression = useQuestionizerStore((state) => state.step_progression);
  const isCurrentStepValid = useQuestionizerStore((state) => state.isCurrentStepValid());

  const point_disabled_style = " step__point step__point--disabled pointer-events-none ";
  const point_active_style = " step__point step__point--active ";
  const point_inactive_style = " step__point ";

  const line_disabled_style = " step_navigation__line step_navigation__line--disabled pointer-events-none ";
  const line_active_style = " step_navigation__line step_navigation__line--active ";
  const line_inactive_style = " step_navigation__line ";

  const reachable = props.index <= step;

  return <button type="button" role="menuitem" tabIndex={0} className={'step_navigation__step'} 
  
		aria-label={
		  `Schritt ${props.label} von ${props.totalSteps} – ` +
		  (props.active
			? "aktiver Schritt"
			: reachable
			? "erreichbar"
			: "nicht erreichbar")
		}
		
      onClick={()=>{
        if(reachable){setStep(props.index, false)}
      }}
      onKeyUp={()=>{
        if ((event.code != " ")  && (event.code != "Enter")) { return } 
        if(reachable){setStep(props.index, false)}
      }}>
      <div role="presentation" className={!reachable ? line_disabled_style : (props.active ? line_active_style : line_inactive_style)}></div>
      <div role="presentation" className={!reachable ? point_disabled_style : (props.active ? point_active_style : point_inactive_style)}>{props.index + 1}</div>
    </button>
}